import * as React from "react"
import { type EntityParty, type EntityTransaction } from "@digits-graphql/frontend/graphql-bearer"
import { LoadingBlock } from "@digits-shared/components/Loaders"
import styled from "styled-components"
import { EditablePartyCell } from "src/frontend/components/Shared/Transactions/TableCells/EditablePartyCell"
import { isTransaction } from "src/frontend/components/Shared/Transactions/types"
import { useTransactionsUpdates } from "src/frontend/components/Shared/Transactions/Updates/TransactionsUpdatesContext"
import { DEFAULT_PARTY_ICON_SIZE } from "src/shared/components/PartyHover/PartyIconHover"

const LoaderContainer = styled.div`
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  gap: 8px;
`

interface PartyCellProps {
  transaction: EntityTransaction
  iconOnly?: boolean
}

export const PartyCell: React.FC<PartyCellProps> = ({ transaction, iconOnly }) => {
  const { allowInlineUpdates, getTransactionUpdate, updateTransaction } = useTransactionsUpdates()
  const updatedParty = getTransactionUpdate(transaction.factId)?.party

  const onPartySelected = React.useCallback(
    (party: EntityParty) => {
      if (!transaction.factId || !isTransaction(transaction)) return
      updateTransaction({ transaction, party })
    },
    [transaction, updateTransaction]
  )

  return (
    <EditablePartyCell
      transaction={transaction}
      updatedParty={updatedParty}
      onPartySelected={onPartySelected}
      closedTimestamp={undefined}
      editable={allowInlineUpdates}
      iconOnly={iconOnly}
    />
  )
}

export const LoadingPartyCell: React.FC = () => (
  <LoaderContainer>
    <LoadingBlock
      width={(DEFAULT_PARTY_ICON_SIZE.pixels ?? 0) + 7}
      height={DEFAULT_PARTY_ICON_SIZE.pixels ?? 0}
    />
    <LoaderContainer css="flex-direction: column; align-items: flex-start">
      <LoadingBlock width="70px" height="14px" />
      <LoadingBlock width="90px" height="14px" />
    </LoaderContainer>
  </LoaderContainer>
)
